<template>
  <v-card class="px-2">
    <v-row>
      <v-col cols="12" lg="10" class="py-2">
        <div></div>
      </v-col>
      <v-col cols="12" lg="2" class="py-2">
          <slot name="actions"></slot>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
    name:"StokListCard",
    props: {

    }
};
</script>

<style>
</style>